var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_COUNTRIES, SET_LEGAL_ENTITY } from '../actions/legalEntity';
var initialState = {
    legalEntity: null,
    countries: [],
};
export default function legalEntityAssignment(state, _a) {
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case SET_LEGAL_ENTITY:
            return __assign(__assign({}, state), { legalEntity: payload });
        case SET_COUNTRIES:
            return __assign(__assign({}, state), { countries: payload });
        default:
            return state;
    }
}
